"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edgeSizes = exports.animate = exports.settings = exports.zindex = exports.fonts = exports.leading = exports.colors = void 0;
var colors = {
  white: '#fff',
  black: '#333',
  blue: {
    primaryDark: '#0094ab',
    primary: '#00a6c2',
    primaryLight: '#17b7da',
    secondaryDark: '#57cadc',
    secondary: '#cff5fd',
    secondaryLight: '#ebfcff'
  },
  cs: {
    primaryDark: '#33a995',
    primary: '#3fB9A4',
    primaryLight: '#1AC7A9',
    secondaryDark: '#79CEBF',
    secondary: '#C5EAE3',
    secondaryLight: '#ebf8f5'
  },
  green: {
    primary: '#24B352',
    light: '#F0FFEB'
  },
  grey: {
    primary: '#666',
    primaryLight: '#999',
    altDark: '#aaa',
    altLight: '#c9c9c9',
    secondaryDark: '#d4d4d4',
    secondary: '#eee',
    secondaryLight: '#f8f8f8'
  },
  orange: {
    darkest: '#FF8C23',
    primary: '#FFA859',
    lightest: '#FCE5D0'
  },
  red: {
    primary: '#E51D1D',
    secondary: '#e45c5c',
    lightest: '#FFF3F3'
  },
  yellow: {
    darkest: '#E0CF2F',
    primary: '#F8E71C',
    secondary: '#fff6ad',
    lightest: '#FFFEEB'
  }
};
exports.colors = colors;
var leading = {
  full: '22px',
  half: '11px',
  third: '8px',
  fourth: '5px',
  eighth: '3px'
};
exports.leading = leading;
var fonts = {
  sans: {
    family: '"Gotham A", "Gotham B", "Helvetica Neue", Helvetica, Arial, sans-serif',
    weight: {
      light: 300,
      normal: 400,
      bold: 500
    },
    size: {
      small: '12px',
      normal: '14px',
      large: '16px',
      xlarge: '18px'
    }
  },
  icons: "\n    font-family: 'CustomIcons';\n    font-style: normal;\n    font-weight: normal;\n    font-variant: none;\n    text-transform: none;\n    speak: none;\n  "
};
exports.fonts = fonts;
var zindex = {
  page: {
    super: 9999
  },
  modal: {
    above: 9001,
    body: 9000,
    below: 8999
  },
  component: {
    aboveBase: 101,
    base: 100,
    belowBase: 99
  }
};
exports.zindex = zindex;
var settings = {
  page: {
    maxWidth: '1920px'
  }
};
exports.settings = settings;
var animate = {
  spin: '1.5s',
  fade: '0.3s',
  pulse: '1.5s',
  transition: '0.3s'
};
exports.animate = animate;
var edgeSizes = {
  none: '0px',
  hair: '1px',
  xsmall: '6px',
  small: '12px',
  medium: '24px',
  large: '48px',
  xlarge: '96px'
};
exports.edgeSizes = edgeSizes;